import React, { Fragment } from 'react';
import { Box } from '@mui/material';

import ScheduleInbound from '../Components/ScheduleInbound/ScheduleInbound';
import useNotificationController from '../Hooks/useNotificationController';

import { ACTIONS } from '../Constants';

import NotificationItem from '../Components/NotificationItem';
import OnCloseFeedback from '../Components/OnCloseFeedback';
import { useSelector } from 'react-redux';

const NotificationBanner = React.memo(() => {
  const [state, handlers] = useNotificationController();
  const isSideNavOpen = useSelector((state) => state?.sidebar?.isSideNavOpen);

  return (
    <Fragment>
      {/* Placeholder box for shifting the page down as banner is positioned absolute */}
      {state?.notificationData?.length ? (
        <Box
          sx={(theme) => ({
            marginLeft: isSideNavOpen ? '260px' : '64px',
            [theme.breakpoints.down('sm')]: {
              marginLeft: '0',
              marginBottom: '-12px !important',
            },
          })}
          display="flex"
          flexDirection="column"
        >
          {state?.notificationData?.map((notification, index) => (
            <NotificationItem state={state} handlers={handlers} notification={notification} key={index} />
          ))}
        </Box>
      ) : null}
      {state.activeAction === ACTIONS.SCHEDULE_INBOUND && (
        <ScheduleInbound
          data={state.activeActionData}
          closeActiveNotificationAction={() => handlers.setActiveAction('')}
          open={state.activeAction === ACTIONS.SCHEDULE_INBOUND}
          onCloseNotification={handlers.onCloseNotification}
        />
      )}
      {state.activeAction === ACTIONS.RECORD_FEEDBACK && (
        <OnCloseFeedback
          data={state.activeActionData}
          open={state.activeAction === ACTIONS.RECORD_FEEDBACK}
          onClose={() => handlers.setActiveAction('')}
        />
      )}
    </Fragment>
  );
});

export default NotificationBanner;
